import React, { useState, useRef, useEffect } from "react";
import { instance } from "../../axios";
import * as yup from "yup";
import { LoginUser, setStorage, Logout } from "../../helper";
import { useStore } from "../../state.js";
import { useNavigate, Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { BgLoader, UiButton, OverlayLoader } from "../../ui.js";
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineMoreVert } from "react-icons/md";

const SelectCompany = ({ ...props }) => {
  const { fruits, addTodo } = useStore((state) => state);
  const { auth, setAuth } = useStore((state) => state);
  let navigat = useNavigate();

  const schema = yup.object().shape({

    company: yup.string().nullable().required('Select company'),

  });
  const url1 = window.location.href;
  const [state, setState] = useState({});
  const [loader, showLoader] = useState(false);

  const userModal = useModal('company');

  const addCompany = (id) => {
    userModal.show({ id }).then((res) => {
      fetchData();
    });
  }

  var doLogin = (e) => {
    showLoader(true)
    var form = document.querySelector("#accform");
    var data = new FormData(form);

    instance({
      method: "post",
      url: "/org_select",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {
          useStore.setState({ org: response.data.org, load_accounts: false, load_items: false, load_series: false });
          navigat("/", { replace: true });
        }
        if (response.data.status == 'error') {
          toast(response.data.msg, { type: "error" });
        }

      })
      .catch(function (response) { });
  };




  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    doLogin()
    // doLogin();
    //reset();
  };

  const handleDelete = (id) => {
    var tid = id.toString();

    showLoader(true)
    instance
      .get("/delete_org?id=" + tid)
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {
          fetchData();
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }

  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      onClick: () => addCompany(e.id),
    },
    {
      key: '2',
      label: (
        <Popconfirm
          title="Delete?"
          description="Are you sure to delete this?"
          onConfirm={() => handleDelete(e.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },


  ];

  const fetchData = () => {



    instance
      .get("/orgs")
      .then(function (response) {
        setState(response.data)
      })
      .catch(function (error) { })
      .then(function () { });
  }


  useEffect(() => {
    fetchData()
  }, []);

  return (
    <div className="container py-5 h-100">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col-12 col-md-8 col-lg-6 col-xl-5">
          <OverlayLoader visible={loader} />
          <div className="card shadow-2-strong">
            <div className="card-body p-5">
              <div className="d-flex justify-content-between">
                <h3 className="mb-5">Select Company</h3>
                <div>
                  {state.master == 1 &&
                    <UiButton className="btn btn-primary btn-sm" onClick={() => addCompany('new')} title="Add Company"></UiButton>
                  }
                </div>
              </div>
              {state.items ?
                <form id="accform" onSubmit={handleSubmit(onSubmitHandler)}>

                  {state.items && state.items.map((val, i) => (
                    <div className="border p-2 mb-3 rounded d-flex align-items-center justify-content-between" key={i}>
                      <div className="form-check " >
                        <input className="form-check-input" type="radio" name="company" id={`acc${i}`} defaultChecked={val.selected == 1 ? true : false} value={val.id} {...register("company")} />
                        <label className="form-check-label " htmlFor={`acc${i}`}>
                          {val.name}
                        </label>
                      </div>
                      {state.master == 1 &&
                        <Dropdown menu={{
                          items: items(val),
                        }}
                          trigger={['click']}
                        >
                          <button className='btn btn-light btn-sm' type="button"><MdOutlineMoreVert /></button>
                        </Dropdown>
                      }
                    </div>

                  ))}
                  {errors.company && <small className="text-danger">{errors.company.message}</small>}
                  <button className="w-100 btn btn-lg btn-primary mt-3" >Select</button>
                </form>
                : <BgLoader />}
            </div>


          </div>
          <div className="text-center mt-3">
            <button className="btn btn-outline-danger" onClick={() => Logout()}>Logout</button>
          </div>
        </div>
      </div>
    </div >
  );
};

export default SelectCompany;
